<template>
  <v-dialog
    v-if="dialog"
    v-model="dialog"
    hide-overlay
    transition="dialog-bottom-transition"
    :max-width="preview ? '50%' : '80%'"
  >
    <BlockUI v-if="loading" message="Atualizando CNH"></BlockUI>
    <v-card height="800px" v-if="!preview">
      <v-toolbar dark color="primary">
        <v-spacer></v-spacer>
        <v-btn icon dark @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-actions v-if="showButtons">
        <v-layout row justify-center>
          <v-btn
            class="ma-3 success white--text"
            @click="$emit('aprovar', user)"
          >
            Aprovar
          </v-btn>
          <v-btn
            class="ma-3 white--text"
            color="error"
            @click="$emit('reprovar', user)"
          >
            Reprovar
          </v-btn>
          <v-btn
            class="ma-3 white--text"
            color="primary darken-1"
            @click="$emit('reprovar-doc', user)"
          >
            Solicitar novas documentações
          </v-btn>
        </v-layout>
      </v-card-actions>
      <v-divider></v-divider>
      <v-container class="grey lighten-5">
        <v-row>
          <v-col
            cols="5"
            sm="12"
            md="5"
            class="d-flex child-flex"
            v-if="user.cnh_uri"
          >
            <pdf v-if="user.cnh_uri.includes('pdf')" :src="user.cnh_uri"></pdf>
            <v-img
              v-else
              :src="user.cnh_uri"
              aspect-ratio="1"
              class="grey lighten-2"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-col>
          <v-col v-else>
            Usuário não possui CNH cadastrada!
          </v-col>
          <v-spacer></v-spacer>
          <v-col
            cols="5"
            sm="12"
            md="5"
            class="d-flex child-flex"
            v-if="user.selfie_uri"
          >
            <v-img
              :src="`${url_bucket + user.selfie_uri}`"
              aspect-ratio="1"
              class="grey lighten-2"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-col>
          <v-col v-else>
            Usuário não possui selfie cadastrada!
          </v-col>
        </v-row>
        <v-layout>
          <v-flex sm1 v-if="user.cnh_uri" class="downdloadBtnCnh mr-4">
            <v-btn @click="download">
              <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 15L17.55 9.54L16.13 8.13L13 11.25V2H11V11.25L7.88 8.13L6.46 9.55L12 15Z"
                />
              </svg>
            </v-btn>
          </v-flex>
          <v-flex sm3>
            <v-file-input
              class="mt-3"
              label="Anexar CNH"
              prepend-icon="send"
              @change="onFileSelected"
            ></v-file-input>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <!-- preview -->
    <v-card v-else>
      <v-card-title class="text-h5 lighten-2">
        Confirme o envio do documento
      </v-card-title>

      <pdf v-if="storedEvent.type.includes('pdf')" :src="selectedFile"></pdf>
      <v-img v-else :src="selectedFile" aspect-ratio="1" class="grey lighten-2">
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>

      <v-card-actions class="sticky ">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="confirmFile">
          Aceitar
        </v-btn>
        <v-btn @click="preview = false">
          voltar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Constants from '../../models/constants/Constants';
import CnhController from '../../controllers/CnhController';
import pdf from 'vue-pdf';
import axios from 'axios';
import UserController from '../../controllers/UserController';
export default {
  components: {
    pdf,
  },
  data() {
    return {
      storedEvent: '',
      selectedFile: null,
      preview: false,
      loading: false,
      cnhController: new CnhController(this.$resource),
      userController: new UserController(this.$resource),
      url_bucket: Constants.URL_BUCKET_PICKNDRIVE,
    };
  },
  methods: {
    onFileSelected(event) {
      this.storedEvent = event;
      if (event !== null) {
        this.preview = true;
        if (event.type.includes('image')) {
          let blob = this.cnhController.eventToBlob(event);
          this.selectedFile = window.URL.createObjectURL(blob);
        } else if (event.type.includes('pdf')) {
          this.selectedFile = window.URL.createObjectURL(event);
        } else {
          this.$awn.warning('Formato de arquivo não suportado');
        }
      }
    },
    async confirmFile() {
      this.loading = true;
      const event = this.storedEvent;
      try {
        if (event.type.includes('image')) {
          await this.cnhController.uploadCnhPdf(event, this.user.id);
          this.$awn.success('CNH atualizada');
        } else if (event.type.includes('pdf')) {
          await this.cnhController.uploadCnhImage(event, this.user.id);
          this.$awn.success('CNH atualizada');
        }
      } catch (error) {
        this.$awn.alert(error);
      } finally {
        let user = await this.userController.getUserById(this.user.id);
        this.preview = false;
        this.user.cnh_uri = user.cnh_url;
        this.loading = false;
      }
    },
    download() {
      const user = this.user;
      axios({
        url: user.cnh_uri,
        method: 'GET',
        responseType: 'blob',
      })
        .then(res => {
          let fileUrl = window.URL.createObjectURL(new Blob([res.data]));
          const parsedType = res.data.type.replace('application/', '');

          const type =
            res.data.type === 'application/octet-stream' ? 'jpeg' : parsedType;

          const downloadUrl = document.createElement('a');
          downloadUrl.href = fileUrl;
          downloadUrl.setAttribute('download', `${user.name}-cnh.${type}`);
          document.body.appendChild(downloadUrl);
          downloadUrl.click();
        })
        .catch(err => {
          console.log(err);
          this.$awn.alert('Erro ao realizar o download');
        });
    },
  },
  props: {
    dialog: Boolean,
    user: Object,
    showButtons: Boolean,
  },
};
</script>
<style scoped>
.downdloadBtnCnh {
  margin-top: 25px;
}
.sticky {
  position: sticky;
  bottom: 10px;
  right: 5px;
  margin-bottom: 20px;
}
</style>
